// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-max[data-v-fbd2e852]{max-height:80vh}.survey[data-v-fbd2e852]{margin-top:2rem;width:100%}", ""]);
// Exports
module.exports = exports;
